import type { ReactNode } from "react";
import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { OverlayShell } from "@/components/ui/overlay";
import { cn } from "@/lib/utils";

export function Modal({
	title,
	description,
	eyebrow,
	onClose,
	isPending = false,
	className,
	component,
	slot,
	children,
}: {
	title: string;
	description?: ReactNode;
	eyebrow?: ReactNode;
	onClose: () => void;
	isPending?: boolean;
	className?: string;
	component?: string;
	slot?: string;
	children: ReactNode;
}) {
	function handleClose() {
		if (!isPending) {
			onClose();
		}
	}

	return (
		<OverlayShell label={title} onClose={handleClose} className="items-center justify-center p-4">
			<div
				data-component={component}
				data-slot={slot}
				data-title={title}
				className={cn("overlay-panel max-w-lg overflow-hidden", className)}
			>
				<header className="flex shrink-0 flex-wrap items-start justify-between gap-4 border-b border-border p-5">
					<div className="min-w-0">
						{!!eyebrow && (
							<div className="mb-1 flex flex-wrap items-center gap-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
								{eyebrow}
							</div>
						)}
						<h2 className="type-section-title text-foreground">{title}</h2>
						{!!description && (
							<div className="mt-1 text-sm text-muted-foreground">{description}</div>
						)}
					</div>
					<Button
						type="button"
						variant="ghost"
						size="sm"
						disabled={isPending}
						onClick={handleClose}
						className="shrink-0"
					>
						<X />
						Fechar
					</Button>
				</header>
				<div className="flex min-h-0 flex-col gap-4 overflow-y-auto p-5">{children}</div>
			</div>
		</OverlayShell>
	);
}
